import { CustomFieldSchemaService } from "../../services/custom-field-schema.service";
import { formatDateHuman, formatTimestampHuman, parseDate } from "../date-utils";
import { CustomListService } from "../../services/custom-list.service";
export async function getCustomFieldSchemas(entityCode) {
    let _resp = await CustomFieldSchemaService.GetCustomFieldSchemasByEntityCode(entityCode).toPromise();
    return _resp.payload;
}
export function initializeCustomFields(schemas) {
    let m = new Object();
    schemas.forEach(x => initializeCustomField(m, x));
    return m;
}
function initializeCustomField(m, schema) {
    let fieldName = schema.customFieldSchema.fieldName;
    let fieldValue = schema.customFieldSchema.defaultValue;
    let fieldTypeCode = schema.customFieldType.code;
    if (fieldTypeCode === "DATEXXXXXX" || fieldTypeCode === "DATETIMEXX") {
        // FIXME: if date, just midnight (use moment)
        fieldValue = new Date().toISOString();
    }
    m[fieldName] = fieldValue;
    return m;
}
export async function makeTableCustomFields(schemas, path) {
    let listFields = schemas.filter(x => x.customFieldSchema.listable === 1).sort((x, y) => x.customFieldSchema.listDisplayOrder - y.customFieldSchema.listDisplayOrder);
    let dropdownFields = listFields.filter(schema => schema.customFieldType.code === 'DROPDOWNXX');
    let listValues = new Map();
    await Promise.all(dropdownFields.map(async (schema) => {
        if (!!schema.customFieldSchema.listSchemaId) {
            let vv = await CustomListService.getCustomListValues(schema.customFieldSchema.listSchemaId).toPromise();
            listValues.set(schema.customFieldSchema.listSchemaId, vv.payload);
        }
    }));
    return listFields.map((schema) => {
        return {
            name: schema.customFieldSchema.fieldName,
            title: schema.customFieldSchema.fieldLabel,
            render: record => {
                let values = null;
                if (path == null)
                    values = record.customFields;
                else
                    values = record[path].customFields;
                if (values == null)
                    return "";
                let v = values[schema.customFieldSchema.fieldName];
                if (v === undefined)
                    return "";
                switch (schema.customFieldType.code) {
                    case "STRINGXXXX":
                        return formatStringField(schema, v);
                    case "FIXNUMXXXX":
                        return formatFixnumField(schema, v);
                    case "FLONUMXXXX":
                        return formatFlonumField(schema, v);
                    case "DATEXXXXXX":
                        return formatDateField(schema, v);
                    case "DATETIMEXX":
                        return formatDateTimeField(schema, v);
                    case "BOOLEANXXX":
                        return formatBooleanField(schema, v);
                    case "DROPDOWNXX": {
                        let listSchemaId = schema.customFieldSchema.listSchemaId;
                        if (!!listSchemaId) {
                            let vv = listValues.get(listSchemaId);
                            return formatDropdownField(schema, v, vv);
                        }
                        else
                            return "";
                    }
                    default:
                        return v.fieldValue;
                }
            }
        };
    });
}
function formatStringField(schema, value) {
    return value;
}
function formatFixnumField(schema, value) {
    return value;
}
function formatFlonumField(schema, value) {
    return value;
}
function formatDateField(schema, value) {
    return formatDateHuman(parseDate(value));
}
function formatDateTimeField(schema, value) {
    return formatTimestampHuman(parseDate(value));
}
function formatBooleanField(schema, value) {
    return `<i class="material-icons">${value === "1" ? "check" : "close"}</i>`;
}
function formatDropdownField(schema, value, listValues) {
    if (listValues == null)
        return "";
    let myOid = parseInt(value);
    let v = listValues.find(x => x.oid === myOid);
    return !!v ? v.description : "";
}
